// extracted by mini-css-extract-plugin
module.exports = {"countContainer":"ReviewSearchCount_countContainer__hwRS2"};